<div class="route-one-jacket-modal">
    <div *ngIf="!isLoading" class="closing-x-wrap">
        <mat-icon class="close-icon condenced" alt="Close dialog" (click)="close()"> close </mat-icon>
    </div>
    <h1 mat-dialog-title>RouteOne Jacket</h1>
    <div mat-dialog-content>
        <ng-container *ngIf="isLoading">
            <div class="loader-wrap">
                <three-dot-loader></three-dot-loader>
            </div>
        </ng-container>
        <ng-container *ngIf="!isLoading && !routeOneResponse">
            <p>
                To retrieve the E-Contract, you need to go into RouteOne or other supported E-Contract system to create the E-Contract. Once that is completed,
                verify that the following information matches what is in that system.
            </p>
            <p class="r1-info">
                <span class="label">First Name: </span>
                {{ data?.deal?.buyer?.firstName || 'N/A' }}
            </p>
            <p class="r1-info">
                <span class="label">Last Name: </span>
                {{ data?.deal?.buyer?.lastName || 'N/A' }}
            </p>
            <p class="r1-info">
                <span class="label">VIN: </span>
                {{ data?.deal?.vehicle?.vin || 'N/A' }}
            </p>
        </ng-container>
        <ng-container *ngIf="!isLoading && routeOneResponse?.error">
            <p>
                {{ routeOneResponse.message }}
            </p>
        </ng-container>
    </div>
    <div mat-dialog-actions>
        <button mat-raised-button color="primary" [disabled]="isLoading" (click)="routeOneResponse?.error ? close() : retrieveRIC()">
            {{ routeOneResponse?.error ? 'Close' : 'Sync With E-Contract' }}
        </button>
    </div>
</div>
